import { lazy } from 'react';

const Login = lazy(() => import('../views/Authentication/Login/Login'));
const Redirect = lazy(() => import('../views/Authentication/Redirect/Redirect'));
const ForgotPassword = lazy(() => import('../views/Authentication/ForgotPassword/ForgotPassword'));
const ActivateWithCode = lazy(() => import('../views/Authentication/ActivateWithCode/ActivateWithCode'));
const ResetPassword = lazy(() => import('../views/Authentication/ResetPassword/ResetPassword'));
const SetupPassword = lazy(() => import('../views/Authentication/SetupPassword/SetupPassword'));
const VerifyEmail = lazy(() => import('../views/Authentication/VerifyEmail/VerifyEmail'));

const authRoutes = [
  {
    path: '/authentication/login',
    name: 'Login',
    icon: 'mdi mdi-account-key',
    component: Login,
  },
  {
    path: '/authentication/redirect',
    name: 'Redirect',
    icon: 'mdi mdi-account-key',
    component: Redirect,
  },
  {
    path: '/authentication/forgot-password',
    name: 'Forgot Password',
    icon: 'mdi mdi-account-key',
    component: ForgotPassword,
  },
  {
    path: '/authentication/activate-with-code',
    name: 'Activate With Code',
    icon: 'mdi mdi-account-key',
    component: ActivateWithCode,
  },
  {
    path: '/reset-password/:token',
    name: 'Reset Password',
    icon: 'mdi mdi-account-key',
    component: ResetPassword,
  },
  {
    path: '/setup-password/:token',
    name: 'Setup Password',
    icon: 'mdi mdi-account-key',
    component: SetupPassword,
  },
  {
    path: '/verify/email/:token',
    name: 'Verify Email',
    icon: 'mdi mdi-account-key',
    component: VerifyEmail,
  },
];
export default authRoutes;
